/**
 * Single source of truth on the relative precedence of all legacy (i.e., p2022) url patterns.
 * Should only ever be edited when a url-pattern is retired.
 */

export const LegacyUrlPatternPrecedence = [
  '',
  'privacy',
  'terms',
  'about',
  'crispr',
  'signin',
  'signin/choose-provider',
  'signup',
  ':institutionUrlIdentifier/signup',
  'tag',
  'bulk-workflows/antibody',
  'bulk-workflows/assembly',
  'bulk-workflows/translation',
  'editor',
  'calendar',
  'getting-started',
  'gs/organizations',
  'gs/bioregistry',
  'role-info',
  'projects/',
  'registries/',
  'search',
  'storage',
  'invite',
  'external-invite',

  // =======================================================

  '_design/:component',

  'organizations/create',
  'organizations/:organizationUrlIdentifier/',
  'organizations/:organizationUrlIdentifier/create-team',
  'organizations/:organizationUrlIdentifier(/:section)',
  'users/:userId',
  'users/:userId/',
  'users/:userId(/:section)',
  'admin(/:section)',
  'access-policies',
  'data-policies/:policyId',
  'schema-policies',
  'schema-policies/policies',
  'schema-policies/settings',
  'schema-policies/:policyId',
  'teams/:teamId(/:section)',
  '(:currentUserUrl/)admin/activity',
  ':currentUserUrl/admin/projects_dashboard/',
  ':currentUserUrl/admin/users_dashboard/',

  'event-subscriptions',
  'ai-connectors',
  'apps',
  'apps/:benchlingAppId',
  'developer/apps',
  'developer/apps/create',
  'developer/apps/:benchlingAppId',
  'api',
  'api/reference',
  'api/:version/reference',
  'config-migration',
  'webhooks/reference',

  'legacy-workflows',
  'workflows/templates',
  'legacy-workflows/templates',
  'workflows/view/:workflowId',
  'legacy-workflows/view/:workflowId',
  'workflows/stage-entries/:stageEntryUrlIdentifier',
  'legacy-workflows/stage-entries/:stageEntryUrlIdentifier',
  'workflows/stage-entries/:stageEntryUrlIdentifier/view',
  'legacy-workflows/stage-entries/:stageEntryUrlIdentifier/view',
  'workflows/templates/view/:workflowTemplateId',
  'legacy-workflows/templates/view/:workflowTemplateId',

  'worklists',
  'worklist-items',

  'requests',
  'requests/:requestId',

  'processes',
  'workflows',
  'processes/:processId',
  'workflows/:processId',
  'process-task-schemas',
  'workflow-task-schemas',
  'process-task-schemas/create',
  'workflow-task-schemas/create',
  'process-task-schemas/:schemaId',
  'workflow-task-schemas/:schemaId',
  'workflow-tasks/:processTaskId',

  'label-printing-settings',
  'inventory-settings',

  'analytics',
  'analytics/analyses/:analysisUrlIdentifier',
  'analytics/dashboards/:analyticsDashboardUrlIdentifier',
  'forms/:formDefinitionId',
  'monomers',

  'connection-schemas',
  'connection-schemas/create',
  'connection-schemas/:schemaId',
  'instrument-gateways',
  'connections/:connectionId',

  'entry-review-processes',
  'entry-review-processes/configuration',
  'entry-review-processes/:reviewLifecycleId',

  ':currentUserUrl',
  ':currentUserUrl/settings',
  ':currentUserUrl/organizations/',
  ':currentUserUrl/ladders/(:ladderId)',
  ':currentUserUrl/enzyme-lists/(:listId)',
  ':currentUserUrl/feature-libraries/(:libraryId)',

  ':currentUserUrl/assay-schemas/requests/',
  ':currentUserUrl/assay-schemas/requests/create',
  ':currentUserUrl/assay-schemas/requests/:assaySchemaId',
  ':currentUserUrl/request-schemas/tasks/',
  ':currentUserUrl/request-schemas/tasks/create',
  ':currentUserUrl/request-schemas/tasks/:schemaId',

  ':currentUserUrl/assay-schemas/results/',
  ':currentUserUrl/assay-schemas/results/create',
  ':currentUserUrl/assay-schemas/results/:assaySchemaId',
  ':currentUserUrl/assay-schemas/results/json/create',
  ':currentUserUrl/assay-schemas/results/json/:assaySchemaId',

  ':currentUserUrl/assay-schemas/runs/',
  ':currentUserUrl/assay-schemas/runs/create',
  ':currentUserUrl/assay-schemas/runs/:assaySchemaId',
  ':currentUserUrl/assay-schemas/runs/json/create',
  ':currentUserUrl/assay-schemas/runs/json/:assaySchemaId',

  ':currentUserUrl/template-collections/',
  ':currentUserUrl/template-collections/:collectionId',
  ':currentUserUrl/f/:folderIdentifier/:itemUrlIdentifier/edit',
  ':currentUserUrl/f/:folderIdentifier/:itemUrlIdentifier/view',
  ':currentUserUrl/templates/:templateUrlIdentifier/view',
  ':currentUserUrl/templates/:templateUrlIdentifier',
  ':currentUserUrl/f_/:folderIdentifier/',

  // TODO (BNCH-97960): Remove the hardcoded 'schema-interfaces' routes once retired
  'schema-interfaces/',
  'schema-interfaces/create',
  'schema-interfaces/:interfaceId',

  ':ownerUrl/registries/:registryUrlIdentifier/general/',
  ':ownerUrl/registries/:registryUrlIdentifier/tag-schemas/',
  ':ownerUrl/registries/:registryUrlIdentifier/tag-schemas/create',
  ':ownerUrl/registries/:registryUrlIdentifier/tag-schemas/:tagSchemaId',
  ':ownerUrl/registries/:registryUrlIdentifier/tag-schemas/:tagSchemaId/:section',
  ':ownerUrl/registries/:registryUrlIdentifier/container-schemas/',
  ':ownerUrl/registries/:registryUrlIdentifier/box-schemas/',
  ':ownerUrl/registries/:registryUrlIdentifier/box-schemas/create',
  ':ownerUrl/registries/:registryUrlIdentifier/box-schemas/:boxSchemaId',
  ':ownerUrl/registries/:registryUrlIdentifier/plate-schemas/',
  ':ownerUrl/registries/:registryUrlIdentifier/plate-schemas/create',
  ':ownerUrl/registries/:registryUrlIdentifier/plate-schemas/:plateSchemaId',
  ':ownerUrl/registries/:registryUrlIdentifier/location-schemas/',
  ':ownerUrl/registries/:registryUrlIdentifier/location-schemas/create',
  ':ownerUrl/registries/:registryUrlIdentifier/location-schemas/:locationSchemaId',
  ':ownerUrl/registries/:registryUrlIdentifier/label-templates/',
  ':ownerUrl/registries/:registryUrlIdentifier/label-templates/create',
  ':ownerUrl/registries/:registryUrlIdentifier/label-templates/:labelTemplateId',
  ':ownerUrl/registries/:registryUrlIdentifier/printers/',
  ':ownerUrl/registries/:registryUrlIdentifier/printers/create',
  ':ownerUrl/registries/:registryUrlIdentifier/printers/:printerId',
  ':ownerUrl/registries/:registryUrlIdentifier/dropdowns/',
  ':ownerUrl/registries/:registryUrlIdentifier/dropdowns/create',
  ':ownerUrl/registries/:registryUrlIdentifier/dropdowns/:selectorId',

  'samples/containers/:containerId',
  'samples/boxes/:boxId',
  'samples/plates/:plateId',
  'samples/locations/:locationId',

  's/:apiIdentifier/edit',
  's/:apiIdentifier/view',
];
